import {Injectable} from '@angular/core';
import {MxAssignmentComponentsService, MxAssignmentGrid} from 'mx-core';
import {
  PrlProductTypeAssignmentComponent
} from '../../view/assignment-components/prl-product-types/components/prl-product-type-assignment/prl-product-type-assignment.component';
import {
  PrlProductAssignmentComponent
} from '../../view/assignment-components/prl-products/components/prl-product-assignment/prl-product-assignment.component';

@Injectable({
  providedIn: 'root'
})
export class AssignmentComponentsService implements MxAssignmentComponentsService {

  private map = new Map<string, new () => MxAssignmentGrid>([
    ['productTypes', PrlProductTypeAssignmentComponent],
    ['products', PrlProductAssignmentComponent]
  ]);

  getComponent(componentName: string): new () => MxAssignmentGrid {
    return this.map.get(componentName);
  }
}
